// import { Card } from "@/Card";
import { useRef, useEffect, useState } from "react";
import NotifySearchArea from "./NotifySearchArea";
import FloatingButton from "@/FloatingButton";
import { IconWrite } from "@/Icon/Wirite";
import { useRouter } from "@tanstack/react-router";
import useNotifyReceive from "^/business/notify/useNotifyReceive";
import NoticeTimeline from "./NoticeTimeline";
import { useBusinessNotifyStore } from "&/businessNotifyList";

const TAB_NAME = "받은 알림장";

const NotifyReceived = () => {
  const { history } = useRouter();
  const loadMoreRef = useRef<HTMLDivElement>(null);

  // 상세에서 뒤로 돌아온 경우에만 스냅샷 복원 (일반 진입은 새로 조회)
  const [restored] = useState(() => {
    const s = useBusinessNotifyStore.getState();
    return s.returning && s.snapshot?.tab === TAB_NAME ? s.snapshot : null;
  });

  const {
    receivedData,
    hasMore,
    onLoad,
    handleSearch,
    filterType,
    setFilterType,
    dropdownOpen,
    setDropdownOpen,
    selectedType,
    setSelectedType,
    searchKeyword,
    searchText,
    setSearchText,
    isLoading,
    page,
  } = useNotifyReceive(restored ?? undefined);

  // 스크롤 복원: 재조회된 리스트가 그려진 뒤 클릭했던 카드가 화면 중앙에 오도록.
  // scrollIntoView 는 상위 스크롤 조상까지 움직여 헤더가 밀리므로 main scrollTop 만 직접 계산
  const scrollRestoredRef = useRef(false);
  useEffect(() => {
    if (!restored || scrollRestoredRef.current) return;
    if (!receivedData || receivedData.length === 0) return;
    scrollRestoredRef.current = true;
    const main = document.getElementById("main");
    if (!main) return;
    requestAnimationFrame(() => {
      const anchor = restored.anchorSeq
        ? main.querySelector<HTMLElement>(
            `[data-noti-seq="${restored.anchorSeq}"]`
          )
        : null;
      if (anchor) {
        const anchorRect = anchor.getBoundingClientRect();
        const mainRect = main.getBoundingClientRect();
        const target =
          main.scrollTop +
          (anchorRect.top - mainRect.top) -
          (main.clientHeight - anchorRect.height) / 2;
        main.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
      } else {
        main.scrollTo({ top: restored.scrollY, behavior: "smooth" });
      }
    });
  }, [restored, receivedData]);

  // 상세/글쓰기로 이동하기 직전 현재 목록 상태 저장 — 뒤로가기 복원용
  const saveSnapshot = (anchorSeq?: number) => {
    const main = document.getElementById("main");
    useBusinessNotifyStore.getState().save({
      tab: TAB_NAME,
      scrollY: main?.scrollTop ?? 0,
      anchorSeq: anchorSeq ?? null,
      page,
      filterType,
      selectedType,
      searchKeyword,
      searchText,
    });
  };

  // 스크롤 하단 도달 시 추가 로드
  useEffect(() => {
    if (!hasMore || isLoading) return;
    const el = loadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) onLoad();
      },
      { root: null, rootMargin: "100px", threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, isLoading, onLoad]);
  // const [receivedData, setReceivedData] = useState<any[]>(dummy);
  // const onLoad = () => {
  //   setReceivedData(receivedData.concat(dummy));
  //   console.log("onLoad");
  // };
  const wiriteButtonClick = () => {
    saveSnapshot();
    history.push("/business/layout/notify-send");
  };
  const handleRead = (item: any) => {
    saveSnapshot(item.notiRecvSeq);
    history.push(
      `/business/layout/notify-detail?noticeSeq=${item.notiRecvSeq}&send=N`
    );
  };
  return (
    <div className="flex-auto p-2 mt-1">
      <NotifySearchArea
        handleSearch={handleSearch}
        filterType={filterType}
        setFilterType={
          setFilterType as React.Dispatch<React.SetStateAction<string>>
        }
        dropdownOpen={dropdownOpen}
        setDropdownOpen={setDropdownOpen}
        selectedType={selectedType}
        setSelectedType={
          setSelectedType as React.Dispatch<React.SetStateAction<string>>
        }
        searchText={searchText}
        setSearchText={setSearchText}
      />
      <div className="px-1 pt-2 pb-1 mb-1">
        <NoticeTimeline
          items={receivedData ?? []}
          variant="received"
          onItemClick={handleRead}
          emptyText="받은 알림장이 없습니다."
        />
        {/* {receivedData?.map((item: any, i: number) => {
          // 알림장 타입인 경우 새로운 DiaryNotificationCard 사용
          if (item.type === "notify" && item.cdNotiType === "NOTI_DIARY") {
            return (
              <DiaryNotificationCard
                key={i}
                petName={item.petName || "반려견"}
                petWeight={item.petWeight || ""}
                petImage={item.petImg}
                date={item.date || ""}
                time={item.time || ""}
                content={item.text || ""}
                onClick={() => handleRead(item.key)}
                className="mb-2"
              />
            );
          }

          // 기존 카드 스타일 사용
          return (
            <Card
              key={i}
              title={item.title}
              type={item.type as "calendar" | "notify" | "gallery"}
              read={item.read}
              onClick={() => handleRead(item.key)}
            >
              <NotificationCard
                text={item.text}
                className="min-w-0 whitespace-pre-wrap line-clamp-3"
              >
                <DiaryHeader data={item} />
                <p
                  className={
                    "min-w-0 text-sm text-gray-500 whitespace-pre-wrap line-clamp-3"
                  }
                >
                  {item.text}
                </p>
              </NotificationCard>
            </Card>
          );
        })} */}
      </div>
      {hasMore && <div ref={loadMoreRef} className="h-4" aria-hidden />}
      {isLoading && receivedData.length > 0 && (
        <div className="flex justify-center py-2 text-gray-500 text-sm">
          불러오는 중...
        </div>
      )}
      <FloatingButton onClick={() => wiriteButtonClick()}>
        <IconWrite />
      </FloatingButton>
    </div>
  );
};

export default NotifyReceived;

// function DiaryHeader({ data }: any) {
//   return (
//     <div className="flex gap-2 items-center mb-2">
//       <img
//         src={data.petImg}
//         alt="프로필"
//         className="object-cover w-10 h-10 rounded-full"
//       />
//       <div className="flex-1">
//         <div className="flex gap-2 items-center">
//           <p className="font-semibold text-m">{data.petName}</p>
//           <p className="text-[#999999] text-[14px]">{data.petWeight}</p>
//         </div>
//         <div className="flex justify-between items-center w-full">
//           <div className="text-gray-400 text-s">
//             <p className="text-[#999999] text-[12px]">{data.date}</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
